import { render, staticRenderFns } from "./GamesHistoryRoute.vue?vue&type=template&id=5547ba10&scoped=true&"
import script from "./GamesHistoryRoute.vue?vue&type=script&lang=js&"
export * from "./GamesHistoryRoute.vue?vue&type=script&lang=js&"
import style0 from "./GamesHistoryRoute.vue?vue&type=style&index=0&id=5547ba10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5547ba10",
  null
  
)

export default component.exports